import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared.module';
import { ComponentsModule } from '../components/components.module';
import { PagesRoutes } from './pages.routing';
import {
  LoadingComponent,
  IdentificationComponent,
  IdentificationHelpComponent,
  IdentificationSuccessComponent,
  ChangePasswordComponent,
  ChangePasswordFormComponent,
  ChangePasswordSuccessComponent
} from '.';
import { ChangePasswordFormDirective } from './change-password-form/change-password-form.directive';


@NgModule({
  declarations: [
    LoadingComponent,
    IdentificationComponent,
    IdentificationHelpComponent,
    IdentificationSuccessComponent,
    ChangePasswordComponent,
    ChangePasswordFormComponent,
    ChangePasswordFormDirective,
    ChangePasswordSuccessComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ComponentsModule,
    PagesRoutes
  ],
  exports: [
    RouterModule,
    LoadingComponent,
    IdentificationComponent,
    IdentificationHelpComponent,
    IdentificationSuccessComponent,
    ChangePasswordComponent,
    ChangePasswordFormComponent,
    ChangePasswordSuccessComponent
  ]
})
export class PagesModule { }
